module.exports = __webpack_public_path__ + "img/collapse.c2fed7c9.svg";